import classNames from 'classnames';
import { useRef, useState } from 'react';
import {
  autoUpdate, flip, offset,
} from '@floating-ui/react-dom';
import { Trash } from '@styled-icons/feather';
import { InterpreterFrom } from 'xstate';
import { useActor } from '@xstate/react';
import { NavbarDropdown, NavbarDropdownMenuColumn } from '@typedream/core';
import { Floating } from '../../../../../components/Floating';
import { useOutsideEventWithCanvas } from '../../../../../utils/eventAlerter';
import Menu from '../../../../Navbar/Menu';
import styles from '../../../../Navbar/NavbarSettingToolbar/NavbarSettingToolbar.module.css';
import sharedStyles from '../../../../Navbar/Shared.module.css';
import { LeftMenuItem } from '../../../../Navbar/LeftMenu';
import { MenuSectionVertical } from '../../../../Navbar/Menu/MenuSectionVertical';
import { SettingButton } from '../../../../../nodes/navbar/components/DropdownMenu/SettingButton';
import { navbarDropdownContainerFSM } from '../finiteStateMachines/NavbarDropdownContainer.fsm';
import { getSelectedNavbarItem } from '../utils';

export function ColumnSettingToolbar(props: {
  machineActor: InterpreterFrom<typeof navbarDropdownContainerFSM>
}) {
  const { machineActor } = props;
  const [machineState, machineSend] = useActor(machineActor);
  const outsideDetectRef = useOutsideEventWithCanvas<HTMLDivElement>('click', () => {
    machineSend({ type: 'ON_MOUSE_LEAVE_ITEM', payload: { state: false } });
  });

  const getSelectedColumnSafe = (
    context: typeof machineState.context,
  ) => {
    const navbarMenuItem = getSelectedNavbarItem<NavbarDropdown>(context);

    if (
      context?.selectedDropdownItemType === 'column'
      && context?.selectedColumnId
    ) {
      // eslint-disable-next-line max-len
      const selectedColumn = navbarMenuItem?.menu.children.find((c) => c.id === context.selectedColumnId);
      return selectedColumn as NavbarDropdownMenuColumn | undefined;
    }

    return undefined;
  };

  const currentSelectedColumn = getSelectedColumnSafe(machineState.context);

  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  return (
    <div className={styles.navbarMenuOptionsContainer} ref={outsideDetectRef}>
      <div
        style={{
          position: 'absolute',
          top: -47.5,
        }}
        ref={ref}
      >
        <SettingButton
          onClick={() => setOpen(!open)}
        >
          Column Settings
        </SettingButton>
      </div>
      {
        open && (
          <Floating
            reference={ref}
            options={{
              placement: 'right-start',
              middleware: [
                offset(5),
                flip(),
              ],
              whileElementsMounted: autoUpdate,
            }}
            autoUpdate
          >

            <Menu>
              <div className={styles.navbarMenuOptions} data-testid="NavbarMenuOptions">
                <div className={classNames(sharedStyles.optionTitle, styles.title)}>
                  Settings
                </div>

                <MenuSectionVertical>
                  <LeftMenuItem
                    icon={<Trash size={15} />}
                    title="Delete Column"
                    onClick={() => {
                      machineSend({
                        type: 'ON_DELETE_COLUMN',
                      });
                    }}
                  />
                </MenuSectionVertical>
              </div>

            </Menu>
          </Floating>
        )
      }

    </div>
  );
}
